import type * as lazyIndex from './lazyIndex';
import { type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';
import { showRefreshToEnableScreenCaptureInfoBar } from './selectors/showRefreshToEnableScreenCaptureInfoBar';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "RefreshToEnableScreenCaptureInfoBar" */ './lazyIndex'),
    { name: 'RefreshToEnableScreenCaptureInfoBar' }
);

export const RefreshToEnableScreenCaptureInfoBar: LazyComponent<{}, unknown, void> =
    createLazyComponent(
        lazyModule,
        m => m.RefreshToEnableScreenCaptureInfoBar,
        undefined,
        undefined,
        {
            onlyImportIf: () => showRefreshToEnableScreenCaptureInfoBar(),
        }
    );
